import axios from "axios";
axios.defaults.headers["X-Requested-With"] = "Axios";
const createHistory = require("history").createHashHistory;
import Constants from "../../../AppConstants/Constants";
import Utilities from "../../../Helpers/Utilities";
import { receivedServerError, receivedUnauthorizedError, receivedExpiredSessionError } from "../../Error/Actions";
import { getCart } from "../../Cart/Actions";
import { toggleBlockingStatus, updateRequestCount } from "../../Status/Actions";
import { setLanguage, setCurrency } from "../../Localization/Actions";
import {
    USER_INFO_RECEIVED,
    USER_EDIT_FAILED,
    USER_UPDATED,
    USER_LOGGED_IN,
    USER_LOGGED_OUT,
    LOGIN_FAILED,
    REGISTER_FAILED,
    PASSWORD_CHANGED,
    PASSWORD_CHANGE_FAILED,
    PASSWORD_RECOVERY_SENT,
    PASSWORD_RECOVERY_FAILED,
    PASSWORD_RESET,
    PASSWORD_RESET_FAILED,
    ADDRESS_FAILED,
    IS_AUTHENTICATED,
    GUEST_ALERT_STATUS_UPDATED,
    BILLING_ADDRESS_ADDED,
    ORDERS_RECEIVED,
    ORDER_DETAIL_RECEIVED,
    COMPANIES_RECEIVED
} from "../Constants";

export function getUserInfo(cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Account/Info"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedUserInfo(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    dispatch(redirectToLoginPage());
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function receivedUserInfo(data) {
    return {
        type: USER_INFO_RECEIVED,
        payload: data
    };
}

export function editUserInfo(data, cb) {
    return function (dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/EditInfo"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(userUpdateFailed({}));
                dispatch(userUpdated());
                dispatch(receivedUserInfo(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(userUpdateFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function userUpdated() {
    return {
        type: USER_UPDATED
    };
}

export function userUpdateFailed(data) {
    return {
        type: USER_EDIT_FAILED,
        payload: data
    };
}

export function login(data, cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/Login"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));

                dispatch(getCart());
                dispatch(setLanguage({ language: res.data.language }));
                dispatch(setCurrency({ currency: res.data.currency }));
                dispatch(loginFailed({}));
                dispatch(userLoggedIn(res.data));
                dispatch(setAuthenticated(true));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(loginFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function guestLogin(data, cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/LoginGuest"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));

                dispatch(getCart());
                dispatch(setLanguage({ language: res.data.language }));
                dispatch(setCurrency({ currency: res.data.currency }));
                dispatch(loginFailed({}));
                dispatch(userLoggedIn(res.data));
                dispatch(setAuthenticated(true));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(loginFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function userLoggedIn(data) {
    // App.unblockUI();
    return {
        type: USER_LOGGED_IN,
        payload: data
    };
}

export function loginFailed(data) {
    return {
        type: LOGIN_FAILED,
        payload: data
    };
}

export function register(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/Register"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(getCart());
                dispatch(registerFailed({}));
                dispatch(userLoggedIn(res.data));
                dispatch(setAuthenticated(true));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(registerFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function registerFailed(data) {
    return {
        type: REGISTER_FAILED,
        payload: data
    };
}

export function changePassword(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/ChangePassword"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(passwordChangeFailed({}));
                dispatch(passwordChanged());
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(passwordChangeFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function passwordChanged() {
    return {
        type: PASSWORD_CHANGED
    };
}

export function passwordChangeFailed(data) {
    return {
        type: PASSWORD_CHANGE_FAILED,
        payload: data
    };
}

export function requestPasswordRecoveryEmail(data, cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/PasswordRecoverySend"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(requestPasswordRecoveryEmailFailed({}));
                dispatch(passwordRecoveryEmailSent());
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(requestPasswordRecoveryEmailFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function passwordRecoveryEmailSent() {
    return {
        type: PASSWORD_RECOVERY_SENT
    };
}

export function requestPasswordRecoveryEmailFailed(data) {
    return {
        type: PASSWORD_RECOVERY_FAILED,
        payload: data
    };
}

export function validatePasswordResetRequest(token, email, cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Account/PasswordResetInfo"), {
            params: { token, email }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    dispatch(redirectToLoginPage());
                } else if (error.response.status === 400) {
                    if (cb && typeof cb === "function") {
                        cb(error.response.data);
                    }
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function resetPassword(data, cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/PasswordReset"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(setAuthenticated(false));
                dispatch(passwordResetFailed({}));
                dispatch(passwordReset());
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(passwordResetFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function passwordReset() {
    return {
        type: PASSWORD_RESET
    };
}

export function passwordResetFailed(data) {
    return {
        type: PASSWORD_RESET_FAILED,
        payload: data
    };
}

export function getCompanies() {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Account/GetCompanies"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedCompanies(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedCompanies(data) {
    return {
        type: COMPANIES_RECEIVED,
        payload: data
    };
}

export function addAddress(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/AddAddress"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(addressFailed({}));
                dispatch(billingAddressAdded(res.data));
                dispatch(receivedUserInfo(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(addressFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function editAddress(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Account/EditAddress"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(addressFailed({}));
                dispatch(billingAddressAdded(res.data));
                dispatch(receivedUserInfo(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 500) {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                } else {
                    dispatch(addressFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function billingAddressAdded(data) {
    return {
        type: BILLING_ADDRESS_ADDED,
        payload: data
    };
}

export function addressFailed(data) {
    return {
        type: ADDRESS_FAILED,
        payload: data
    };
}

export function logout(cb) {
    return function(dispatch) {
        dispatch(userLoggedOut());

        return axios.get(Utilities.buildUrl("/Account/Logout"))
            .then(() => {
                dispatch(receivedServerError(false));

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(receivedServerError(true, error.response.data));
                dispatch(receivedServerError(false));
            });
    };
}

function userLoggedOut(data) {
    // App.unblockUI();
    return {
        type: USER_LOGGED_OUT
    };
}

export function setAuthenticated(isAuthenticated) {
    return {
        type: IS_AUTHENTICATED,
        payload: isAuthenticated
    };
}

export function setGuestAlertStauts(show) {
    return {
        type: GUEST_ALERT_STATUS_UPDATED,
        payload: show
    };
}

export function redirectToLoginPage() {
    createHistory().push(Constants.ENDPOINTS.LOGIN);
}

// region Orders
export function getOrders() {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Account/Orders"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedOrders(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    dispatch(redirectToLoginPage());
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedOrders(data) {
    return {
        type: ORDERS_RECEIVED,
        payload: data
    };
}

export function getOrderDetail(orderId) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl(`/Account/OrderDetail?orderId=${orderId}`))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedOrderDetail(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedOrderDetail(data) {
    return {
        type: ORDER_DETAIL_RECEIVED,
        payload: data
    };
}
// endregion